'use strict';

const Mn = require('backbone.marionette');
require('backbone.stickit');
const Uploader = require('data/ui/view/content/uploader');
const ContentListView = require('balus/ui/view/body/process/toolbar/content-list');
const ContainerRepository = require('data/domain/repository/container/index');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const URIObjectAPI = require('data/infra/api/object/index');
const ContentRepository = require('data/domain/repository/content/index');
const FolderItemView = require('data/ui/view/content/folder-item');
const Template = require('balus/ui/template/body/process/toolbar/content-edit.hbs');
const UploadTabTemplate = require('balus/ui/template/body/process/toolbar/upload-tab.hbs');
const URITabTemplate = require('balus/ui/template/body/process/toolbar/uri-tab.hbs');
const EmptyTabTemplate = require('balus/ui/template/body/process/toolbar/empty-tab.hbs');
const ContentListEmptyTemplate = require('balus/ui/template/body/process/toolbar/content-list-empty.hbs');

const UploadTabView = Mn.View.extend({
    template: UploadTabTemplate,
    regions: {
        uploader: '.content-uploader'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:storageObjectId': 'uploadable'
    },
    bindings: {
        'input.nameUpload': 'name'
    },
    childViewEvents: {
        'addedfile': 'onAddedFile', //Uploader
        'success': 'onSuccess' //Uploader
    },

    onRender: function() {
        // 始めから file が渡ってきている場合は `file` に値が入る
        const file = this.getOption('file');
        const project = this.getOption('project');
        this.showChildView('uploader', new Uploader({
            projectId: project.id
        }));

        if(file) {
            const uploader = this.getChildView('uploader');
            uploader.on('ready', () => {
                uploader.addFile(file);
            });
        }

        this.stickit(this.model);
    },

    onAttach: function() {
        $.material.init();
    },

    onAddedFile: function(file) {
        this.trigger('formEmpty');
        this.model.set({name: file.name});
    },

    onSuccess: function(file, j) {
        this.model.set({
            storageObjectId: j.id,
            thumbnailURI: j.thumbnailURI,
            uploaded: true
        });
    },

    uploadable: function() {
        if(this.model.get('name') && this.model.get('storageObjectId')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

const URITabView = Mn.View.extend({
    template: URITabTemplate,
    modelEvents: {
        'change:name': 'uploadable',
        'change:uri': 'uploadable'
    },
    bindings: {
        'input.nameURI': 'name',
        'input.uri': 'uri'
    },

    onRender: function() {
        this.stickit(this.model);

        this.listenTo(this.model, 'change:uri', () => {
            if(!this.model.get('uri')) {
                return;
            }

            URIObjectAPI.getURIObject(this.model.get('uri'))
                .then(obj => {
                    if(!this.model.get('name')) {
                        this.$('input.nameURI').val(obj.title);
                        this.$('input.nameURI').trigger('input');
                    }
                });
        });
    },

    onAttach: function() {
        $.material.init();
    },

    uploadable: function() {
        if(this.model.get('name') && this.model.get('uri')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

const EmptyTabView = Mn.View.extend({
    template: EmptyTabTemplate,
    modelEvents: {
        'change:name': 'uploadable'
    },
    bindings: {
        'input.nameEmpty': 'name'
    },

    /**
     * 空のデータは URI と StorageObjectId がともに null
     */
    initialize: function() {
        this.model.set({
            uri: null,
            storageObjectId: null
        });
    },

    onRender: function() {
        this.stickit(this.model);
    },

    onAttach: function() {
        $.material.init();
    },

    uploadable: function() {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

class ContentListEmptyView extends Mn.View {
    get template() {
        return ContentListEmptyTemplate;
    }

    get tagName() {
        return 'li';
    }

    get className() {
        return 'list-item';
    }

    onRender() {
        this.$el.css('margin', '20px').css('text-align', 'center');
    }
}

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        uploadTab: '.upload-tab-wrapper',
        uriTab: '.uri-tab-wrapper',
        emptyTab: '.empty-tab-wrapper',
        attachmentsList: '.attachments-list-wrapper',
        contentList: '.content-list-wrapper'
    },
    ui: {
        uploadTab: '.upload-tab',
        uriTab: '.uri-tab',
        emptyTab: '.empty-tab',
        chooseTab: '.choose-tab'
    },
    childViewEvents: {
        'select:content': 'uploadable',
        'formFilled': 'formFilled',
        'formEmpty': 'formEmpty'
    },
    formFilled: function() {
        this.trigger('formFilled');
    },
    formEmpty: function() {
        this.trigger('formEmpty');
    },

    initialize: function() {
        this._original = this.model;
        this.model = this.model ? this.model.clone() : new Backbone.Model();
        if(this._original) {
            const dataSource = this._original.getLatestVersion().getDataSource();
            const uri = dataSource.getURI();
            this.model.set({
                uri: uri,
                storageObjectId: null,
                thumbnailURI: null
            });
        }

        this._rootContainer = null;
        this._attachmentsContainer = null;

        this.fetchContainer();
    },

    fetchContainer: function() {
        if (this._rootContainer && this._attachmentsContainer) {
            return new Promise(resolve => {
                resolve();
            });
        }

        const context = this.getOption('context');
        const project = context.getProject();

        return new Promise(resolve => {
            ContainerRepository.find(project)
                .fetchRootOnce()
                .then(rootContainer => {
                    this._rootContainer = rootContainer;

                    ContainerRepository.find(project)
                        .fetchChildContainersOnce(this._rootContainer)
                        .then(containers => {
                            // その中に attachments という名前のシステムフォルダがあれば、それ用の枠に表示する
                            this._attachmentsContainer = containers.find(c => {
                                return c.isSystem() && c.getSystemName() === 'attachments';
                            });
                        });
                });
        });
    },

    onRender: function () {
        const project = this.getOption('project');

        // このアクションに関連付けられている全ての ActionWork Content を取得する
        // （既存データから選択する際に、既に追加済みのデータと突合する必要があるため)
        // モーダル開いた段階で取得を開始して、操作をブロックする必要はない。
        this.fetchPresentContents();

        // 「既存データから選択」や「アップロード後の既存データとの統合サジェスト」のために、
        // このプロジェクトに存在する全てのデータを取得する。
        // モーダル開いた段階で取得を開始して、操作をブロックする必要はない。
        this.fetchContainer()
            .then(() => {
                ContentRepository.find(project)
                    .fetchContentsOnce(this._rootContainer.id, 5)
                    .then(contents => {
                        contents.fetchNextAll();
                    });
                ContentRepository.find(project)
                    .fetchContentsOnce(this._attachmentsContainer.id, 5)
                    .then(contents => {
                        contents.fetchNextAll();
                    });
            });

        this.showChildView('uploadTab', new UploadTabView({
            model: this.model.clone(),
            project: this.getOption('project'),
            file: this.getOption('file')
        }));
        this.showChildView('uriTab', new URITabView({
            model: this.model.clone()
        }));
        this.showChildView('emptyTab', new EmptyTabView({
            model: this.model.clone()
        }));

        this.model = this.getChildView('uploadTab').getModel();
        this.stickit(this.model);

        this.ui.uploadTab.on('show.bs.tab', () => {
            this.model = this.getChildView('uploadTab').getModel();
            this.getChildView('uploadTab').uploadable();
        });
        this.ui.uriTab.on('show.bs.tab', () => {
            this.model = this.getChildView('uriTab').getModel();
            this.getChildView('uriTab').uploadable();
        });
        this.ui.emptyTab.on('show.bs.tab', () => {
            this.model = this.getChildView('emptyTab').getModel();
            this.getChildView('emptyTab').uploadable();
        });
        this.ui.chooseTab.on('show.bs.tab', () => {
            this.renderChooseTab();
            this.chooseTab = true;
        });

        return this;
    },

    onAttach: function() {
        $.material.init();
    },

    renderChooseTab: function() {
        const context = this.getOption('context');
        const project = this.getOption('project');

        Promise.all([
            this.fetchContainer()
                .then(() => {
                    // rootContainer 配下の Container(フォルダ) 一覧を取得する
                    this.renderChooseTabAttachmentsFolder(context, project);

                    // rootContainer 配下の Data 一覧を取得する
                    return ContentRepository.find(project)
                        .fetchContentsOnce(this._rootContainer.id, 5);
                }),
            this.fetchPresentContents()
        ]).then(values => {
            const contents = values[0];
            const presentContents = values[1];

            // フォルダ配下の DataContent は全件取得する
            contents.fetchNextAll();

            this.showChildView('contentList',
                new ContentListView({
                    context: context,
                    collection: contents,
                    presentContents: presentContents,
                    emptyView: ContentListEmptyView,
                })
            );

            this.ui.chooseTab.on('hidden.bs.tab', () => {
                this.resetActiveContents();
                this.chooseTab = false;
            });
        });
    },

    /**
     * ChooseTab(既存データから選択タブ)の「添付ファイル」フォルダをレンダリングする
     *
     * @param context
     * @param project
     */
    renderChooseTabAttachmentsFolder: function(context, project){
        Promise.all([
            this.fetchContainer(),
            this.fetchPresentContents()
        ])
            .then(values => {
                const presentContents = values[1];

                if (this._attachmentsContainer) {
                    this.showChildView('attachmentsList', new FolderItemView({
                        contentListView: ContentListView,
                        context: context,
                        model: this._attachmentsContainer,
                        presentContents: presentContents,
                        emptyView: ContentListEmptyView,
                    }));

                    // 「添付ファイル」フォルダ配下の DataContent も全件取得する
                    ContentRepository.find(project)
                        .fetchContentsOnce(this._attachmentsContainer.id, 5)
                        .then(contents => {
                            contents.fetchNextAll();
                        });
                }
            });
    },

    /**
     * このアクションに関連付けられている Content を全件取得する
     */
    fetchPresentContents: function() {
        // このViewは、body/process/toolbar/content-edit にあるが、
        // Timeline などのアクション以外のコンテキストで呼び出されることもある。
        const inActionToolbar = this.getOption('inActionToolbar');
        if (!inActionToolbar) {
            return new Promise(resolve => {
                resolve([]);
            });
        }
        const context = this.getOption('context');
        const project = this.getOption('project');
        const action = context.getAction();
        const actionWorkRepository = ContentActionWorkRepository.find(project);

        return actionWorkRepository
            .fetchAllActionWorkContentsByAction(action)
            .then(() => {
                const presentActionWorkContents = actionWorkRepository.getActionWorksByAction(action);
                this._fetchPresentContents = _.map(presentActionWorkContents.models, (actionWork) => {
                    return actionWork.getWork().getTarget();
                });
                return this._fetchPresentContents;
            });
    },

    uploadable: function () {
        const activeContents = this.getActiveContents();
        if(activeContents && activeContents.length > 0) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getActiveContents: function () {
        if(this.chooseTab) {
            let activeContents = this.getChildView('contentList').getActiveContents();

            // コメント添付ファイル用フォルダが存在すれば、その配下の Content も取得する
            if (this.getChildView('attachmentsList')) {
                const activeAttachments = this.getChildView('attachmentsList').getActiveContents();
                activeContents = activeContents.concat(activeAttachments);
            }

            return activeContents;
        }
    },

    resetActiveContents: function () {
        this.getChildView('contentList').resetActiveContents();
        if (this.getChildView('attachmentsList')) {
            this.getChildView('attachmentsList').resetActiveContents();
        }
    },

    getContent: function () {
        return {
            name: this.model.get('name'),
            uri: this.model.get('uri'),
            storageObjectId: this.model.get('storageObjectId'),
            thumbnailURI: this.model.get('thumbnailURI'),
            uploaded: this.model.get('storageObjectId')
        }
    },
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/toolbar/content-edit.js